import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { isValidElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { isMessage } from '../../lib/utils';

import BasicButton, { BasicButtonProps } from '../buttons/BasicButton';

import styles from '../../styles/menus/menu.module.css';

export interface MenuItemProps extends MenuItem {
    active?: boolean;
    className?: string;
    buttonClassName?: string;
    activeClassName?: string;
}

export interface MenuProps extends BasicButtonProps {
    items?: MenuItemProps[];
    buttonComponent?: React.ElementType;
    className?: string | null;
    itemsClassName?: string | null;
    itemClassName?: string | null;
    buttonClassName?: string | null;
    activeClassName?: string | null;
}

function Menu({
    items = null,
    buttonComponent: ButtonComponent = BasicButton,
    className = null,
    itemsClassName = null,
    itemClassName = null,
    buttonClassName = null,
    activeClassName = null,
    ...props
}: MenuProps) {
    return (
        <nav className={classNames([styles.container, className])}>
            <ul className={classNames([styles.items, itemsClassName])}>
                {(items || []).map(
                    ({
                        id = null,
                        label = null,
                        icon = null,
                        href = null,
                        external = false,
                        active = false,
                        className: customClassName = null,
                        buttonClassName: customButtonClassName = null,
                        activeClassName: customActiveClassName = null,
                        ...itemProps
                    }: MenuItem) => (
                        <li
                            key={id}
                            className={classNames([styles.item, itemClassName, customClassName])}
                        >
                            <ButtonComponent
                                {...props}
                                {...itemProps}
                                href={href}
                                external={external}
                                active={active}
                                className={classNames([
                                    styles.button,
                                    buttonClassName,
                                    customButtonClassName,
                                    {
                                        [styles.withIcon]: icon !== null,
                                        [activeClassName]: active && activeClassName !== null,
                                        [customActiveClassName]:
                                            active && customActiveClassName !== null,
                                    },
                                ])}
                            >
                                {icon !== null ? (
                                    <span className={styles.icon}>
                                        {isValidElement(icon) ? (
                                            icon
                                        ) : (
                                            <FontAwesomeIcon icon={icon} />
                                        )}
                                    </span>
                                ) : null}
                                {isMessage(label) ? (
                                    <FormattedMessage {...(label as any)} />
                                ) : (
                                    label
                                )}
                            </ButtonComponent>
                        </li>
                    ),
                )}
            </ul>
        </nav>
    );
}

export default Menu;
